var Blazy = require("plugins/lazy-load-images/blazy.min.js");
var lazyLoader;
var initialised = false;

function removeSiblingSpinner(element){
    var parent = element.parentNode;
    var childNodes = parent.children;
    var i=0, ok=0, loader = undefined;
    for(i=0; i<childNodes.length && ok==0; i++){
        if(childNodes[i].className.indexOf("spinner") >= 0){
            loader = childNodes[i];
            ok=1;
        }
    }
    if(loader){
        parent.removeChild(loader);
    }
};

function removeChildSpinner(element){
    var childNodes = element.children;
    var i=0, ok=0, loader = undefined;
    for(i=0; i<childNodes.length && ok==0; i++){
        if(childNodes[i].className.indexOf("spinner") >= 0){
            loader = childNodes[i];
            ok=1;
        }
    }
    if(loader){
        element.removeChild(loader);
    }
}

function revalidate(){
    if(initialised){
        lazyLoader.revalidate();
    }
    else{
        init();
        lazyLoader.revalidate();
    }
}

function init(options){
    if(!initialised){
        lazyLoader = new Blazy({
            offset: 200,
            success: function(element){
                var elementTag = element.tagName.toLowerCase();
                if(elementTag == "img"){
                    removeSiblingSpinner(element);
                }
                else{
                    if(elementTag == "div"){
                        removeChildSpinner(element);
                    }
                }
            },
            error: function(element, msg){
                var elementTag = element.tagName.toLowerCase();
                if(elementTag == "img"){
                    removeSiblingSpinner(element);
                    element.src="";
                }
                else{
                    if(elementTag  == "div"){
                        removeChildSpinner(element);
                        element.style.backgroundColor = "transparent";
                    }
                }
            }
        });
        initialised = true;
    }
}

module.exports = {
    init: init,
    revalidate: revalidate
};
